import Sanitizer from 'sanitizer'

const TagSanitizer = {
  install (app) {
    app.config.globalProperties.$tagSanitize = (input) => {
      /**
       * params {String}
       * return {String}
       */
      return Sanitizer.unescapeEntities(
        input,
        (uri) => { return uri }
      )
    }
  }
}

export default TagSanitizer
